module Meevo.Plugins.InventoryCount {
    export class ProductInventoryTypeModalController {
        static $inject = [
            "meevo.components.modal.ModalService",
            "options"
        ];

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService,
            public options : any
        ) { 
            if (options.product && options.product.displayName) {
                options.product.displayName = options.product.displayName.replace(/\|/g, ' ');
            }
        }

        $onInit() { 
            console.log('Product Inventory Type Modal', this.options);
        }

        closeModal() {
            this.modalService.hide();
        }

        currentInventoryTypeChange(val) {
            this.modalService.hideWithResponse(val);
        }
        
    }

    angular.module("meevo.plugins.inventoryCount")
        .controller("meevo.plugins.inventoryCount.ProductInventoryTypeModalController", ProductInventoryTypeModalController);
}

